import { ContainerModule } from '@evertel/di'

import { DepartmentAgreementStore } from './store'
import { AgreementGateController, AgreementController, AgreementsLogController, AgreementAcceptanceController } from './controllers'

const DI_MODULES = [
    new ContainerModule((m) => {
        m.bind(DepartmentAgreementStore).toSelf().inSingletonScope()
        m.bind(AgreementAcceptanceController).toSelf()
        m.bind(AgreementGateController).toSelf()
        m.bind(AgreementController).toSelf()
        m.bind(AgreementsLogController).toSelf()
    })
]

export { DI_MODULES }
